import { ArrowRightCircle, Menu, X } from 'react-feather';

import { useMobile } from '@/hooks';

import styles from './NavigationToggle.module.css';

interface NavigationToggleProps {
  onClick?: TypeAny;
  open: boolean;
}

export function NavigationToggle({ open = false, onClick }: NavigationToggleProps) {
  const isMobile = useMobile();

  const iconClose = isMobile ? Menu : ArrowRightCircle;
  const iconOpen = isMobile ? X : ArrowRightCircle;

  const ToggleIcon = open ? iconOpen : iconClose;

  return (
    <button
      className={styles.navigationToggle}
      data-is-open={open && !isMobile}
      onClick={onClick}
      type="button"
    >
      <ToggleIcon />
    </button>
  );
}
